// extracted by mini-css-extract-plugin
module.exports = {"container":"DataTable_container__2yJ1-","test":"DataTable_test__B4eDP","errorMessage":"DataTable_errorMessage__-6nEo"};